import TemplateManagement from "@/components/artwork/TemplateManagement";
import CropSettingsList from "./CropSettingsList";
import { CropSettings } from "@/interfaces/crop-settings";
import { useState } from "react";
import templateApi from "@/api/template";
import { Template } from "@/interfaces/template.interface";

interface Props {
  onSelect?: (cropSettings: CropSettings) => void;
}

export default function CropSettingsManagement({ onSelect }: Props) {
  const [cropSettings, setCropSettings] = useState<CropSettings>();

  const onRemove = (template: Template) => {
    if (!cropSettings) return;

    templateApi
      .updateOneById(template._id, { cropSettingsId: null })
      .finally(() => setCropSettings({ ...cropSettings }));
  };

  return (
    <div className="flex h-full w-full flex-1 overflow-auto">
      <div className="h-full w-full overflow-auto">
        <CropSettingsList onSelect={onSelect} onChange={setCropSettings} />
      </div>
      {!onSelect && (
        <div className="flex w-full border-l-[1px] border-gray-300">
          <div className="w-full">
            <TemplateManagement
              filter={
                cropSettings ? { cropSettingsId: cropSettings?._id } : undefined
              }
              header={
                cropSettings
                  ? `Templates using ${cropSettings.name} crop settings`
                  : ""
              }
              onRemove={onRemove}
            />
          </div>
        </div>
      )}
    </div>
  );
}
